<template>
  <section class="pointer-events-none touch-none hidden lg:block sticky top-1/2 -translate-y-1/2 w-full h-[30vh]">
    <div class="pointer-events-none touch-none absolute top-0 left-0 w-full h-full z-2 flex items-center justify-center">
      <div class="text-ellie-blue whitespace-pre-line font-semibold uppercase text-center text-6xl md:text-[4.167vw] big-screen:text-[6vw] leading-[1]">
        <h1 class="animate-title-works">
          <div class="opacity-[0] translate-y-[50%] inline-block">F</div>
          <div class="opacity-[0] translate-y-[50%] inline-block">e</div>
          <div class="opacity-[0] translate-y-[50%] inline-block">a</div>
          <div class="opacity-[0] translate-y-[50%] inline-block">t</div>
          <div class="opacity-[0] translate-y-[50%] inline-block">u</div>
          <div class="opacity-[0] translate-y-[50%] inline-block">r</div>
          <div class="opacity-[0] translate-y-[50%] inline-block">e</div>
          <div class="opacity-[0] translate-y-[50%] inline-block">d</div>
          <div class="opacity-[0] translate-y-[100%] md:inline-block ml-4"/>
          <div class="opacity-[0] translate-y-[100%] inline-block">w</div>
          <div class="opacity-[0] translate-y-[100%] inline-block">o</div>
          <div class="opacity-[0] translate-y-[100%] inline-block">r</div>
          <div class="opacity-[0] translate-y-[100%] inline-block">k</div>
          <div class="opacity-[0] translate-y-[100%] inline-block">s</div>
        </h1>
      </div>
    </div>
  </section>
</template>

<script setup>
const { $gsap, $ScrollTrigger } = useNuxtApp();

const init = () => {
  $gsap.to('.animate-title-works div', {
    scrollTrigger: {
      trigger: '.trigger-works-title-animation',
      start: '-20% -20%',
      end: '40% 40%',
      scrub: true,
    },
    stagger: 0.1,
    opacity: 1,
    y: 0,
    ease: 'power1.out'
  });
  
};

onMounted(() => {
  nextTick(() => {
    const to = setTimeout(() => {
      init();
      clearTimeout(to);
    }, 1000);
  });
});
</script>